import userSaga from '~/sagas/user/user.saga';

export default userSaga;
